import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraBadge, SpecraButton, SpecraText } from '@mono/ui-components/ensigns';
import { SpecraUnverifiedClaim } from '@mono/ui-components/lieutenants';
import { Testids } from '@mono/ui-selectors';
import { useState } from 'react';
import { ClaimActionsMenu } from './ClaimActionsMenu';
import { ClaimAudienceControl } from './ClaimAudienceControl';
const KIND_LABEL = {
    HEARSAY: 'Hearsay',
    ANALYST_RESEARCH: 'Analyst note',
    DOCUMENT: 'Document'
};
const shortDay = (d)=>`${d.getUTCDate()} ${d.toLocaleDateString('en-US', {
        month: 'short',
        timeZone: 'UTC'
    })}`;
/** "{heard from}, {venue} {d MMM}" — the parts that are known, nothing invented. */ export function claimAttribution(claim) {
    const where = [
        claim.venue,
        claim.heardOn ? shortDay(claim.heardOn) : ''
    ].filter(Boolean).join(' ');
    return [
        claim.heardFromName,
        where
    ].filter(Boolean).join(', ');
}
/** One claim: the dashed box, its audience control and its actions. */ export function IntelClaimItem({ claim }) {
    const [pickerOpen, setPickerOpen] = useState(false);
    const note = claim.kind === 'HANDLING_NOTE';
    return /*#__PURE__*/ _jsx(SpecraUnverifiedClaim, {
        "data-testid": Testids.registryHearsay.claim,
        kind: note ? 'note' : 'claim',
        tone: note ? 'neutral' : 'warning',
        kindLabel: KIND_LABEL[claim.source],
        claim: `“${claim.statement}”`,
        attribution: claimAttribution(claim) || undefined,
        confidence: claim.confidence.toLowerCase(),
        verified: claim.verification === 'CORROBORATED',
        actions: /*#__PURE__*/ _jsxs("span", {
            className: "inline-flex items-center gap-[var(--space-1)]",
            children: [
                claim.verification === 'CONTRADICTED' && /*#__PURE__*/ _jsx(SpecraBadge, {
                    variant: "danger",
                    children: "Contradicted"
                }),
                /*#__PURE__*/ _jsx(ClaimAudienceControl, {
                    claim: claim,
                    pickerOpen: pickerOpen,
                    onPickerOpenChange: setPickerOpen
                }),
                /*#__PURE__*/ _jsx(ClaimActionsMenu, {
                    claim: claim,
                    onChangeAudience: ()=>setPickerOpen(true)
                })
            ]
        })
    });
}
/**
 * The Intel rail section shared by Person, Company and GovOrg pages: every
 * claim renders through SpecraUnverifiedClaim; "Add" only when the server says
 * the viewer may create.
 */ export function intelClaimsSection(claims, opts) {
    return {
        id: opts.id ?? 'intel',
        title: opts.title ?? 'Intel',
        action: opts.canCreate ? /*#__PURE__*/ _jsx(SpecraButton, {
            variant: "ghost",
            size: "xs",
            onClick: opts.onAdd,
            "data-testid": Testids.registryHearsay.addButton,
            children: "Add"
        }) : undefined,
        children: /*#__PURE__*/ _jsx("div", {
            className: "space-y-[var(--space-2)]",
            "data-testid": Testids.registryHearsay.railSection,
            children: claims.length === 0 ? /*#__PURE__*/ _jsx(SpecraText, {
                as: "p",
                size: "body-ui",
                tone: "muted",
                children: "No intel yet."
            }) : claims.map((c)=>/*#__PURE__*/ _jsx(IntelClaimItem, {
                    claim: c
                }, c.id))
        })
    };
}
